export const IsNumeric = (str: string): boolean => {
    return !isNaN(Number(str));
}

// potentially remove this?
export const NumberValidation = (input: string, isPositive?: boolean): string =>
    isPositive ?
        input.replace(/[^.\d]+/g, '') :
        input.replace(/[^.^-\d]+/g, '');
